import * as React from "react";
import Youtube from '../assets/logos/logo-youtube.svg';
import Twitch from '../assets/logos/logo-twitch.svg';
import Discord from '../assets/logos/logo-discord.svg';
import Patreon from '../assets/logos/logo-patreon.svg';
//import Bluesky from '../assets/logos/logo-bluesky.svg';
import Paypal from '../assets/logos/logo-paypal.svg';

const Socials: any = {
  YouTube: { link: 'https://www.youtube.com/@NetizenKing', icon: <Youtube className="h-5 w-5 svg-bg" /> },
  Twitch: { link: 'https://www.twitch.tv/NetizenKing', icon: <Twitch className="h-5 w-5 svg-bg" /> },
  Discord: { link: 'https://www.patreon.com/posts/free-discord-for-106582712', icon: <Discord className="h-5 w-5 svg-bg" /> },
  Patreon: { link: 'https://www.patreon.com/NetizenKing', icon: <Patreon className="h-5 w-5 svg-bg" /> },
  //Bluesky: { link: 'https://bsky.app/profile/NetizenK.ing', icon: <Bluesky className="h-5 w-5 svg-bg" /> },
  Paypal: { link: 'https://paypal.me/NetizenKing', icon: <Paypal className="h-5 w-5 svg-bg" /> },
  };

export default Socials;